import { useLocation } from "react-router";
import { Helmet } from "react-helmet";

export default function MetaContainer() {
  const { pathname } = useLocation();
  const page = pathname.split("/")[1];

  return (
    <Helmet>
      <title>
        {page ? `${page[0].toUpperCase() + page.slice(1)} - ` : "Home - "}
        {import.meta.env.VITE_TITLE || "EDUVAA"}
      </title>
    </Helmet>
  );
}
